// extracted by mini-css-extract-plugin
export default {"label":"O2IwnYITWrdFH5i_NvZ1","expand-more":"FAdE_d6Sl3YmG0Wx0R4Q","expandMore":"FAdE_d6Sl3YmG0Wx0R4Q"};